export const isAppUi = (): boolean => {
  return window?.location?.href?.includes('/360');
};

export const isAdminUi = (): boolean => {
  return window?.location?.href?.includes('/__admin__');
};
